import axiosInstance from "./axiosInstance";

const SiteMapAPI = {
    getSiteMap: () => {
        try {
            return axiosInstance.get("/sitemap.json");
        } catch (error) {
            console.error("SiteMapAPI.getSiteMap", error);
            return null;
        }
    },
    getSiteMapEn: () => {
        try {
            return axiosInstance.get("/en/sitemap.json");
        } catch (error) {
            console.error("SiteMapAPI.getSiteMap", error);
            return null;
        }
    },
};

export default SiteMapAPI;
